

// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { ref, get } from 'firebase/database';
// import { database } from '../firebase';
// import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// const Slider = () => {
//   const navigate = useNavigate();
//   const [slides, setSlides] = useState([]);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isHovered, setIsHovered] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const sliderRef = useRef(null);
//   const intervalRef = useRef(null);

//   // Fetch slides from Firebase
//   useEffect(() => {
//     const fetchSlides = async () => {
//       try {
//         const slidesRef = ref(database, 'school/slider/images');
//         const snapshot = await get(slidesRef);
        
//         if (snapshot.exists()) {
//           // Convert the snapshot to an array and sort by order
//           const slidesData = Object.entries(snapshot.val())
//             .map(([id, slide]) => ({
//               id,
//               ...slide,
//               // Ensure order is a number
//               order: typeof slide.order === 'number' ? slide.order : 0
//             }))
//             // Sort slides by their order property
//             .sort((a, b) => a.order - b.order);
          
//           setSlides(slidesData);
//         } else {
//           toast.info('No slider images found in database');
//         }
//       } catch (error) {
//         toast.error('Failed to load slider images');
//         console.error("Database error:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
    
//     fetchSlides();
//   }, []);

//   // Auto-rotate slides with pause on hover
//   useEffect(() => {
//     const startInterval = () => {
//       intervalRef.current = setInterval(() => {
//         setCurrentIndex(prev => (prev + 1) % slides.length);
//       }, 5000);
//     };

//     const stopInterval = () => {
//       if (intervalRef.current) clearInterval(intervalRef.current);
//     };

//     if (slides.length > 1 && !isHovered) startInterval();
//     else stopInterval();

//     return () => stopInterval();
//   }, [slides.length, isHovered]);

//   const goToSlide = index => setCurrentIndex(index);
//   const goToNext = () => setCurrentIndex(prev => (prev + 1) % slides.length);
//   const goToPrev = () => setCurrentIndex(prev => (prev - 1 + slides.length) % slides.length);

//   if (loading) {
//     return (
//       <div style={styles.loadingContainer}>
//         <div style={styles.skeletonLoader}></div>
//       </div>
//     );
//   }

//   if (slides.length === 0) {
//     return (
//       <div style={styles.placeholder}>
//         <div style={styles.placeholderContent}>
//           <svg style={styles.placeholderIcon} viewBox="0 0 24 24">
//             <path fill="currentColor" d="M8.5,13.5L11,16.5L14.5,12L19,18H5M21,19V5C21,3.89 20.1,3 19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19Z" />
//           </svg>
//           <p style={styles.placeholderText}>No slides available</p>
//         </div>
//       </div>
//     );
//   }

//  return (
//   <div
//     style={styles.sliderContainer}
//     onMouseEnter={() => setIsHovered(true)}
//     onMouseLeave={() => setIsHovered(false)}
//   >
//     {slides.map((slide, index) => (
//       <div 
//         key={slide.id}
//         style={{
//           ...styles.slideContainer,
//           opacity: index === currentIndex ? 1 : 0,
//           zIndex: index === currentIndex ? 1 : 0,
//         }}
//       >
//         <img
//           src={slide.url}
//           alt={slide.altText}
//           style={styles.fullSizeImage}
//           onError={(e) => {
//             e.target.onerror = null;
//             e.target.src = 'https://via.placeholder.com/1920x1080?text=Image+Not+Found';
//           }}
//         />
//         <div style={styles.imageOverlay}></div>
//       </div>
//     ))}

//     {/* {slides[currentIndex]?.altText && (
//       <div style={styles.textOverlay}>
//         <h2 style={styles.overlayTitle}>{slides[currentIndex].altText}</h2>
//         {slides[currentIndex].description && (
//           <p style={styles.overlayDescription}>{slides[currentIndex].description}</p>
//         )}
//       </div>
//     )} */}

//     {slides.length > 1 && (
//       <>
//         <button 
//           style={styles.prevButton} 
//           onClick={goToPrev} 
//           aria-label="Previous slide"
//         >
//           <svg style={styles.arrowIcon} viewBox="0 0 24 24">
//             <path fill="currentColor" d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />
//           </svg>
//         </button>

//         <button 
//           style={styles.nextButton} 
//           onClick={goToNext} 
//           aria-label="Next slide"
//         >
//           <svg style={styles.arrowIcon} viewBox="0 0 24 24">
//             <path fill="currentColor" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
//           </svg>
//         </button>

//         <div style={styles.pagination}>
//           {slides.map((_, index) => (
//             <button
//               key={index}
//               style={{
//                 ...styles.dot,
//                 backgroundColor: index === currentIndex ? '#fff' : 'rgba(255,255,255,0.3)',
//                 transform: index === currentIndex ? 'scale(1.3)' : 'scale(1)',
//                 width: index === currentIndex ? '24px' : '12px',
//                 borderRadius: index === currentIndex ? '4px' : '50%',
//               }}
//               onClick={() => goToSlide(index)}
//               aria-label={`Go to slide ${index + 1}`}
//             />
//           ))}
//         </div>
//       </>
//     )}
//   </div>
// );
// };

// // Styles remain the same as in your previous implementation
// const styles = {
//   sliderContainer: {
//     position: 'relative',
//     width: '100vw',
//     height: '100vh',
//     overflow: 'hidden',
//     margin: 0,
//     padding: 0,
//   },
//   slideContainer: {
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     width: '100%',
//     height: '100%',
//     transition: 'opacity 1s ease-in-out',
//   },
//   fullSizeImage: {
//     width: '100%',
//     height: '100%',
//     objectFit: 'cover',
//     objectPosition: 'center',
//   },
//   imageOverlay: {
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     width: '100%',
//     height: '100%',
//     background: 'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 50%, transparent 100%)',
//     zIndex: 1,
//   },
//   textOverlay: {
//     position: 'absolute',
//     bottom: '80px',
//     left: 0,
//     right: 0,
//     textAlign: 'center',
//     padding: '20px',
//     maxWidth: '800px',
//     margin: '0 auto',
//     zIndex: 2,
//     color: '#fff',
//     textShadow: '0 2px 4px rgba(0,0,0,0.5)',
//   },
//   overlayTitle: {
//     fontSize: 'clamp(24px, 4vw, 48px)',
//     fontWeight: '700',
//     marginBottom: '16px',
//     lineHeight: '1.2',
//     transform: 'translateY(20px)',
//     opacity: 0,
//     animation: 'slideUp 0.8s ease forwards 0.3s',
//   },
//   overlayDescription: {
//     fontSize: 'clamp(16px, 2vw, 20px)',
//     fontWeight: '300',
//     margin: '0 auto',
//     maxWidth: '600px',
//     lineHeight: '1.6',
//     transform: 'translateY(20px)',
//     opacity: 0,
//     animation: 'slideUp 0.8s ease forwards 0.5s',
//   },
//   prevButton: {
//     position: 'absolute',
//     top: '50%',
//     left: '40px',
//     transform: 'translateY(-50%)',
//     width: '60px',
//     height: '60px',
//     borderRadius: '50%',
//     background: 'rgba(255,255,255,0.1)',
//     backdropFilter: 'blur(8px)',
//     border: '1px solid rgba(255,255,255,0.2)',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     cursor: 'pointer',
//     zIndex: 10,
//     transition: 'all 0.3s ease',
//     ':hover': {
//       background: 'rgba(255,255,255,0.2)',
//       transform: 'translateY(-50%) scale(1.1)',
//     }
//   },
//   nextButton: {
//     position: 'absolute',
//     top: '50%',
//     right: '40px',
//     transform: 'translateY(-50%)',
//     width: '60px',
//     height: '60px',
//     borderRadius: '50%',
//     background: 'rgba(255,255,255,0.1)',
//     backdropFilter: 'blur(8px)',
//     border: '1px solid rgba(255,255,255,0.2)',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     cursor: 'pointer',
//     zIndex: 10,
//     transition: 'all 0.3s ease',
//     ':hover': {
//       background: 'rgba(255,255,255,0.2)',
//       transform: 'translateY(-50%) scale(1.1)',
//     }
//   },
//   arrowIcon: {
//     width: '32px',
//     height: '32px',
//     color: '#fff',
//     filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))',
//   },
//   pagination: {
//     position: 'absolute',
//     bottom: '40px',
//     left: '50%',
//     transform: 'translateX(-50%)',
//     display: 'flex',
//     gap: '10px',
//     zIndex: 10,
//     alignItems: 'center',
//   },
//   dot: {
//     height: '4px',
//     transition: 'all 0.3s ease',
//     cursor: 'pointer',
//     padding: 0,
//     border: 'none',
//     outline: 'none',
//   },
// };

// // Add these global styles for animations
// const styleTag = document.createElement('style');
// styleTag.innerHTML = `
//   @keyframes slideUp {
//     from {
//       transform: translateY(20px);
//       opacity: 0;
//     }
//     to {
//       transform: translateY(0);
//       opacity: 1;
//     }
//   }
// `;
// document.head.appendChild(styleTag);

// export default Slider;












import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ref, get } from 'firebase/database';
import { database } from '../firebase';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Slider = () => {
  const navigate = useNavigate();
  const [slides, setSlides] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const sliderRef = useRef(null);
  const intervalRef = useRef(null);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  // Check for mobile on mount and resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Fetch slides from Firebase
  useEffect(() => {
    // Helper function to remove token from Firebase Storage URLs
    const stripToken = (url) => {
      if (!url) return url;
      try {
        const urlObj = new URL(url);
        urlObj.searchParams.delete('token');
        return urlObj.toString();
      } catch {
        return url.replace(/&token=[^&]+/, '').replace(/\?token=[^&]+&?/, '?');
      }
    };

    const fetchSlides = async () => {
      try {
        const slidesRef = ref(database, 'school/slider/images');
        const snapshot = await get(slidesRef);
        
        if (snapshot.exists()) {
          const slidesData = Object.entries(snapshot.val())
            .map(([id, slide]) => ({
              id,
              ...slide,
              url: stripToken(slide.url),
              order: typeof slide.order === 'number' ? slide.order : 0
            }))
            .sort((a, b) => a.order - b.order);
          
          setSlides(slidesData);
        } else {
          toast.info('No slider images found in database');
        }
      } catch (error) {
        toast.error('Failed to load slider images');
        console.error("Database error:", error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchSlides();
  }, []);

  // Auto-rotate slides with pause on hover (desktop only)
  useEffect(() => {
    const startInterval = () => {
      intervalRef.current = setInterval(() => {
        setCurrentIndex(prev => (prev + 1) % slides.length);
      }, 5000);
    };

    const stopInterval = () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };

    if (slides.length > 1 && !isHovered && !isMobile) startInterval();
    else stopInterval();

    return () => stopInterval();
  }, [slides.length, isHovered, isMobile]);

  // Touch event handlers for mobile swipe
  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (touchStart - touchEnd > 50) {
      goToNext();
    }

    if (touchStart - touchEnd < -50) {
      goToPrev();
    }
  };

  const goToSlide = index => setCurrentIndex(index);
  const goToNext = () => setCurrentIndex(prev => (prev + 1) % slides.length);
  const goToPrev = () => setCurrentIndex(prev => (prev - 1 + slides.length) % slides.length);

  const getStyles = (mobile) => ({
    sliderContainer: {
      position: 'relative',
      width: '100vw',
      height: mobile ? '60vh' : '100vh',
      overflow: 'hidden',
      margin: 0,
      padding: 0,
      touchAction: 'pan-y',
    },
    slideContainer: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      transition: 'opacity 0.8s ease-in-out',
    },
    fullSizeImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: 'center',
    },
    imageOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 50%, transparent 100%)',
      zIndex: 1,
    },
    textOverlay: {
      position: 'absolute',
      bottom: mobile ? '60px' : '80px',
      left: 0,
      right: 0,
      textAlign: 'center',
      padding: mobile ? '15px' : '20px',
      maxWidth: '800px',
      margin: '0 auto',
      zIndex: 2,
      color: '#fff',
      textShadow: '0 2px 4px rgba(0,0,0,0.5)',
    },
    overlayTitle: {
      fontSize: mobile ? 'clamp(20px, 5vw, 32px)' : 'clamp(24px, 4vw, 48px)',
      fontWeight: '700',
      marginBottom: mobile ? '8px' : '16px',
      lineHeight: '1.2',
      transform: 'translateY(20px)',
      opacity: 0,
      animation: 'slideUp 0.8s ease forwards 0.3s',
    },
    overlayDescription: {
      fontSize: mobile ? 'clamp(14px, 3vw, 18px)' : 'clamp(16px, 2vw, 20px)',
      fontWeight: '300',
      margin: '0 auto',
      maxWidth: '600px',
      lineHeight: '1.6',
      transform: 'translateY(20px)',
      opacity: 0,
      animation: 'slideUp 0.8s ease forwards 0.5s',
    },
    prevButton: {
      position: 'absolute',
      top: '50%',
      left: mobile ? '15px' : '40px',
      transform: 'translateY(-50%)',
      width: mobile ? '40px' : '60px',
      height: mobile ? '40px' : '60px',
      borderRadius: '50%',
      background: 'rgba(255,255,255,0.1)',
      backdropFilter: 'blur(8px)',
      border: mobile ? 'none' : '1px solid rgba(255,255,255,0.2)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      zIndex: 10,
      transition: 'all 0.3s ease',
      ':hover': !mobile ? {
        background: 'rgba(255,255,255,0.2)',
        transform: 'translateY(-50%) scale(1.1)',
      } : {}
    },
    nextButton: {
      position: 'absolute',
      top: '50%',
      right: mobile ? '15px' : '40px',
      transform: 'translateY(-50%)',
      width: mobile ? '40px' : '60px',
      height: mobile ? '40px' : '60px',
      borderRadius: '50%',
      background: 'rgba(255,255,255,0.1)',
      backdropFilter: 'blur(8px)',
      border: mobile ? 'none' : '1px solid rgba(255,255,255,0.2)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      zIndex: 10,
      transition: 'all 0.3s ease',
      ':hover': !mobile ? {
        background: 'rgba(255,255,255,0.2)',
        transform: 'translateY(-50%) scale(1.1)',
      } : {}
    },
    arrowIcon: {
      width: '24px',
      height: '24px',
      color: '#fff',
      filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))',
    },
    pagination: {
      position: 'absolute',
      bottom: mobile ? '20px' : '40px',
      left: '50%',
      transform: 'translateX(-50%)',
      display: 'flex',
      gap: mobile ? '8px' : '10px',
      zIndex: 10,
      alignItems: 'center',
    },
    dot: {
      height: mobile ? '3px' : '4px',
      transition: 'all 0.3s ease',
      cursor: 'pointer',
      padding: 0,
      border: 'none',
      outline: 'none',
    },
    loadingContainer: {
      position: 'relative',
      width: '100vw',
      height: mobile ? '60vh' : '100vh',
      backgroundColor: '#f0f0f0',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    skeletonLoader: {
      width: '100%',
      height: '100%',
      background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
      backgroundSize: '200% 100%',
      animation: 'loading 1.5s infinite',
    },
    placeholder: {
      position: 'relative',
      width: '100vw',
      height: mobile ? '60vh' : '100vh',
      backgroundColor: '#f5f5f5',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    placeholderContent: {
      textAlign: 'center',
      color: '#999',
    },
    placeholderIcon: {
      width: '60px',
      height: '60px',
      marginBottom: '20px',
      opacity: 0.5,
    },
    placeholderText: {
      fontSize: '18px',
      margin: 0,
    },
  });

  const styles = getStyles(isMobile);

  if (loading) {
    return (
      <div style={styles.loadingContainer}>
        <div style={styles.skeletonLoader}></div>
      </div>
    );
  }

  if (slides.length === 0) {
    return (
      <div style={styles.placeholder}>
        <div style={styles.placeholderContent}>
          <svg style={styles.placeholderIcon} viewBox="0 0 24 24">
            <path fill="currentColor" d="M8.5,13.5L11,16.5L14.5,12L19,18H5M21,19V5C21,3.89 20.1,3 19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19Z" />
          </svg>
          <p style={styles.placeholderText}>No slides available</p>
        </div>
      </div>
    );
  }

  return (
    <div
      style={styles.sliderContainer}
      onMouseEnter={() => !isMobile && setIsHovered(true)}
      onMouseLeave={() => !isMobile && setIsHovered(false)}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      ref={sliderRef}
    >
      {slides.map((slide, index) => (
        <div 
          key={slide.id}
          style={{
            ...styles.slideContainer,
            opacity: index === currentIndex ? 1 : 0,
            zIndex: index === currentIndex ? 1 : 0,
          }}
        >
          <img
            src={slide.url}
            alt={slide.altText}
            style={styles.fullSizeImage}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = 'https://placehold.co/1920x1080?text=Image+Not+Found';
            }}
          />
          <div style={styles.imageOverlay}></div>
        </div>
      ))}
{/* 
      {slides[currentIndex]?.altText && (
        <div style={styles.textOverlay}>
          <h2 style={styles.overlayTitle}>{slides[currentIndex].altText}</h2>
          {slides[currentIndex].description && (
            <p style={styles.overlayDescription}>{slides[currentIndex].description}</p>
          )}
        </div>
      )} */}

      {slides.length > 1 && (
        <>
          <button 
            style={styles.prevButton} 
            onClick={goToPrev} 
            aria-label="Previous slide"
          >
            <svg style={styles.arrowIcon} viewBox="0 0 24 24">
              <path fill="currentColor" d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />
            </svg>
          </button>

          <button 
            style={styles.nextButton} 
            onClick={goToNext} 
            aria-label="Next slide"
          >
            <svg style={styles.arrowIcon} viewBox="0 0 24 24">
              <path fill="currentColor" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
            </svg>
          </button>

          <div style={styles.pagination}>
            {slides.map((_, index) => (
              <button
                key={index}
                style={{
                  ...styles.dot,
                  width: index === currentIndex ? (isMobile ? '20px' : '24px') : (isMobile ? '10px' : '12px'),
                  backgroundColor: index === currentIndex ? '#fff' : 'rgba(255,255,255,0.3)',
                  borderRadius: index === currentIndex ? '4px' : '50%',
                }}
                onClick={() => goToSlide(index)}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

// Add global styles for animations
const styleTag = document.createElement('style');
styleTag.innerHTML = `
  @keyframes slideUp {
    from {
      transform: translateY(20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;
document.head.appendChild(styleTag);

export default Slider;